import NameLinkCell from '@/components/NameLinkCell';
import type { SampleWithNamesPublic } from '@/types';
import React, { type FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

export interface InstrumentRunCellRendererProps {
  data?: SampleWithNamesPublic;
}

const InstrumentRunCellRendererComponent: FC<InstrumentRunCellRendererProps> = ({ data }) => {
  const { t } = useTranslation('studies');

  if (!data) return null;

  return (
    <NameLinkCell
      ariaLabel={t('goToInstrumentRun')}
      id={data.instrument_run_id}
      name={data.instrument_run_name}
      params={{ instrumentRunId: String(data.instrument_run_id) }}
      size="xs"
      testId="instrument-run-link-button"
      to="/instrument_runs/$instrumentRunId"
    />
  );
};

export const InstrumentRunCellRenderer = memo(InstrumentRunCellRendererComponent);

export default InstrumentRunCellRenderer;
